<template>
  <div class="auth-wrapper">
    <div class="auth-panel" v-if="!timeout">
      <div class="logo-holder d-flex align-items-center justify-content-between">
        <div class="title">Login</div>
        <img src="" alt="">
      </div>
      <div class="form-holder">
        <form action="">
          <div class="form-group">
            <div class="custom-label">{{ $static('login.login', 'Логін:') }}</div>
            <input type="text" class="form-control custom-input" :placeholder="$static('login.login-ne', 'Ваш логін')"
              v-model="login">
          </div>
          <div class="form-group">
            <div class="custom-label">{{ $static('login.password', 'Пароль:') }}</div>
            <input type="password" class="form-control custom-input" :placeholder="$static('login.login-p', 'Пароль')"
              v-model="password">
          </div>
          <div class="remember-forgot justify-content-between">
            <div class="remember">
              <div class="default-checkbox">
                <input id="remember_me" name="remember" type="checkbox" checked="">
                <label for="remember_me">{{ $static('login.remember', 'Запам\'ятати') }}</label>
              </div>
            </div>
            <div class="forgot-password">
              <router-link :to="{ name: 'forgot' }" class="default-link">
                <span class="text">{{ $static('login.forget', 'Забули пароль?') }}</span>
              </router-link>
            </div>
          </div>
          <div class="button-holder">
            <button class="default-btn btn-accent" @click.prevent.stop="sendLoginApiCall">
              <span class="text">{{ $static('login.enter', 'Увійти') }}</span>
            </button>
          </div>
        </form>

      </div>
    </div>
    <div v-else>
      <div class="back-link">
        <a href="https://ux.im/app">
          <span class="icon icon-left"></span>
          <span class="link-text">Перейти до оплати</span>
        </a>
      </div>
      <h4
        v-html="$static('login.timeouterror', 'Web-Версія вашого магазину наразі недоступна через закінчення терміну підписки. <br>Для поновлення  доступу та продовження використання UX Web Bot, будь ласка, здійсніть необхідну оплату.')">
      </h4>
    </div>
    <div class="blur-box">
      <div class="back-link">
        <a href="https://t.me/uxwebbot">
          <span class="icon icon-left"></span>
          <span class="link-text">{{ $static('login.back', 'Повернутись назад') }}</span>
        </a>
      </div>
      <h1
        v-html="$static('login.attent1', 'Доступ до админ панелі можливий лише з компьютеру у повній web-версії сайту.')">
      </h1>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '@/api';

export default {
  name: 'AdminLogin',
  components: {},
  data() {
    return {
      login: '',
      password: '',
      timeout: false
    }
  },
  mounted() {
    if (window.isTimeout) {
      this.timeout = true
    }
  },
  methods: {
    sendLoginApiCall() {
      return axios.post('/auth/login', { login: this.login, password: this.password }).then(response => response.data)
        .then(data => {
          if (data.error) {
            this.$notify({
              title: this.$static('notify.password-title', 'Пароль'),
              type: 'error',
              text: data.error
            });
          } else {
            this.$router.push({ name: 'Dashboard' })
          }
        }).catch(err => {
          if (err.response.data.error === 'Valid timeout') {
            this.timeout = true
            return
          }
          let data = err.response.data;

          this.$notify({
            title: this.$static('notify.password-title', 'Пароль'),
            type: 'error',
            text: data.error
          });
        })
    }
  }
}
</script>

<style scoped>
.blur-box {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1111111;
  background: rgba(247, 247, 247, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

@media (min-width : 800px) {
  .blur-box {
    display: none;
  }
}
</style>
